import apiClient from "./ApiInterceptor";

export const fetchAgreements = async () => {
    const res = await apiClient.get("/agreements");
    return res
};

export const fetchAgreementBySlug = async (slug) => {
    const res = await apiClient.get(`/agreements/${slug}`);
    return res;
};

export const saveUsedAgreement = async (slug, userId) => {
    const res = await apiClient.post(`/agreements/${slug}/used`, { user_id: userId });
    return res;
}